import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountCrmConnections implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountCrmConnectionsContainer";
    }
    render(){
        // The Add form is a plain GET form (it leaves the portal for the vendor's consent screen). Navigate with the
        // selected option's data-href so the site id (adminSiteId) always travels with the connect request.
        const form=this.zidx.peakidxShadowRoot.querySelector(".zidxAccountCrmConnectionsContainer .zidxCrmAddForm") as HTMLFormElement|null;
        if(!form || form.dataset.bound==="1"){
            return;
        }
        form.dataset.bound="1";
        form.addEventListener("submit", (event:Event)=>{
            event.preventDefault();
            const select=form.querySelector("select") as HTMLSelectElement;
            const option=select.options[select.selectedIndex];
            const href=option ? option.getAttribute("data-href") : "";
            if(href){
                window.location.href=href;
            }
        });
    }
}
